import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'underscore';

import SUMMARY from '@/assets/data/summary.json';
import PROJECTS from '@/assets/data/projects.json';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    host: 'http://debye.io',
    menuDropdown: {
      show: false,
      icon: 'fal fa-bars'
    },
    projectDropdown: {
      show: false,
      icon: 'chevron-down-light'
    },
    navItems: [
      { name: 'Home', path: '/' },
      { name: 'Featured Projects', path: '/project' },
      { name: 'Resume', path: '/resume' }
    ],
    project: {},
    projectList: [],
    projectTypeIcon: {
      'DESIGN': 'magic',
      'IMPLEMENTATION': 'code',
      'RESEARCH': 'users-class',
      'UNDEFINED': 'bone-break',
      'RESUME': 'file-pdf'
    },
    showWhiteHeader: true,            // true for all but Home until scrolled
    summary: SUMMARY
  },
  mutations: {
    setMenuDropdown(state, bool) {
      state.menuDropdown.show = bool;
    },
    setProjectDropdown(state, bool) {
      state.projectDropdown.show = bool;
      state.projectDropdown.show
        ? state.projectDropdown.icon = 'fal fa-chevron-up'
        : state.projectDropdown.icon = 'fal fa-chevron-down';
    },
    setProject(state, data) {
      state.project = data;
    },
    setProjectList(state, list) {
      state.projectList = list;
    },
    setWhiteHeader(state, bool) {
      state.showWhiteHeader = bool;
    }
  },
  actions: {
    loadProjectList({ commit }) {
      // instead of making an axios call...
      // doesn't need to re-query the list every time but it's fast so let it be...
      const list = _.sortBy(PROJECTS, 'sort');
      commit('setProjectList', list);
    },
    loadProjectById(context, data) {
      // instead of making an axios call...
      const matched = this.state.projectList.filter(
        item => item.id === data.id.toString()
      );
      if (matched !== null && matched.length > 0) {
        // grab first matched item IF more than one found
        context.commit('setProject', matched[0]);
        // quiet the Promise error
        data.router.push(`/project/${data.id}`);
      } else {
        console.error('>>> no project match', data.id)
        data.router.push({ name: 'error' });
      }
    },
    updateMenuDropdown(context, bool) {
      context.commit('setMenuDropdown', bool);
    },
    updateProjectDropdown(context, bool) {
      context.commit('setProjectDropdown', bool);
    },
    showWhiteNav(context, bool) {
      context.commit('setWhiteHeader', bool);
    }
  }
});
